(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  // Mobile Search Bar Dynamic Placeholder with Typed Effect
  class MobileSearchBar extends HTMLElement {
    constructor() {
      super();
      this.searchInput = this.querySelector('.mobile-search-input');
      this.suggestions = [];
      this.currentIndex = 0;
      this.rotationSpeed = 3000;
      this.intervalId = null;
      this.typedTimeoutId = null;
      this.isTyping = false;
      this.currentText = '';
      this.typeSpeed = 100; // Speed of typing in ms
      this.backSpeed = 50;  // Speed of backspacing in ms
      this.startDelay = 500; // Delay before starting to type
      this.backDelay = 1000; // Delay before starting to backspace
      
      if (this.searchInput) {
        this.init();
      }
    }

    init() {
      // Get suggestions from data attribute
      const suggestionsData = this.searchInput.dataset.searchSuggestions;
      const rotationSpeed = this.searchInput.dataset.rotationSpeed;
      
      if (suggestionsData) {
        this.suggestions = suggestionsData.split(',').map(s => s.trim()).filter(s => s);
        this.rotationSpeed = parseInt(rotationSpeed) || 3000;
        
        // Get typing speed settings from section settings (if available)
        const typeSpeed = this.searchInput.dataset.typeSpeed;
        const backspaceSpeed = this.searchInput.dataset.backspaceSpeed;
        
        if (typeSpeed) this.typeSpeed = parseInt(typeSpeed);
        if (backspaceSpeed) this.backSpeed = parseInt(backspaceSpeed);
        
        if (this.suggestions.length > 0) {
          this.startTypedAnimation();
        }
      }

      // Add white background on click/tap
      this.searchInput.addEventListener('click', () => {
        const headerSection = document.querySelector('.shopify-section-header');
        if (headerSection) {
          headerSection.classList.add('is-active');
        }
      });

      // Stop typing animation when user focuses on input
      this.searchInput.addEventListener('focus', () => {
        this.stopTypedAnimation();
        this.searchInput.placeholder = 'Search...';
        // Add is-active class to header section to trigger existing transparent header styles
        const headerSection = document.querySelector('.shopify-section-header');
        if (headerSection) {
          headerSection.classList.add('is-active');
        }
      });

      // Restart typing animation when user leaves input (if empty)
      this.searchInput.addEventListener('blur', () => {
        if (!this.searchInput.value.trim()) {
          this.startTypedAnimation();
          // Remove is-active class from header section
          const headerSection = document.querySelector('.shopify-section-header');
          if (headerSection) {
            headerSection.classList.remove('is-active');
          }
        }
      });

      // Stop typing animation when user types
      this.searchInput.addEventListener('input', () => {
        if (this.searchInput.value.trim()) {
          this.stopTypedAnimation();
          // Add is-active class to header section
          const headerSection = document.querySelector('.shopify-section-header');
          if (headerSection) {
            headerSection.classList.add('is-active');
          }
        } else if (!this.searchInput.matches(':focus')) {
          this.startTypedAnimation();
          // Remove is-active class from header section
          const headerSection = document.querySelector('.shopify-section-header');
          if (headerSection) {
            headerSection.classList.remove('is-active');
          }
        }
      });

      // Initialize predictive search if enabled
      this.initPredictiveSearch();
    }

    initPredictiveSearch() {
      const predictiveSearchContainer = this.querySelector('.predictive-search--mobile');
      if (!predictiveSearchContainer) return;

      let searchTimeout;
      const SEARCH_DELAY = 300; // Debounce delay

      // Check if predictive search is enabled globally
      const isPredictiveSearchEnabled = document.querySelector('[data-predictive-search]') !== null;
      if (!isPredictiveSearchEnabled) return;

      this.searchInput.addEventListener('input', (e) => {
        clearTimeout(searchTimeout);
        const query = e.target.value.trim();

        if (query.length < 2) {
          this.hidePredictiveSearch();
          return;
        }

        // Show loading state
        this.showPredictiveSearchLoading();

        searchTimeout = setTimeout(() => {
          this.performPredictiveSearch(query);
        }, SEARCH_DELAY);
      });

      // Hide predictive search when clicking outside
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) {
          this.hidePredictiveSearch();
          // Also remove is-active class when clicking outside
          if (!this.searchInput.value.trim()) {
            const headerSection = document.querySelector('.shopify-section-header');
            if (headerSection) {
              headerSection.classList.remove('is-active');
            }
          }
        }
      });

      // Hide predictive search on escape key
      this.searchInput.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.hidePredictiveSearch();
          this.searchInput.blur(); // This will trigger the blur event and remove the class
        }
      });
    }

    async performPredictiveSearch(query) {
      try {
        const searchUrl = `${window.routes?.predictive_search_url || '/search/suggest.json'}?q=${encodeURIComponent(query)}&resources[type]=query,product,collection,article,page&resources[limit]=6`;
        const response = await fetch(searchUrl);
        
        if (response.ok) {
          const data = await response.json();
          this.renderPredictiveSearchResults(data);
        } else {
          this.hidePredictiveSearch();
        }
      } catch (error) {
        console.error('Predictive search error:', error);
        this.hidePredictiveSearch();
      }
    }

    renderPredictiveSearchResults(data) {
      const predictiveSearchContainer = this.querySelector('.predictive-search--mobile');
      if (!predictiveSearchContainer) return;

      let html = '<div class="predictive-search__results">';
      
      // Render search suggestions (queries)
      if (data.resources?.results?.queries?.length) {
        html += '<div class="predictive-search__section">';
        html += '<h3 class="predictive-search__heading">Suggestions</h3>';
        data.resources.results.queries.forEach(query => {
          html += `
            <a href="${query.url}" class="predictive-search__item">
              <div class="predictive-search__item-content">
                <span class="predictive-search__item-title">${query.text}</span>
              </div>
            </a>
          `;
        });
        html += '</div>';
      }
      
      // Render products
      if (data.resources?.results?.products?.length) {
        html += '<div class="predictive-search__section">';
        html += '<h3 class="predictive-search__heading">Products</h3>';
        data.resources.results.products.forEach(product => {
          // Handle different possible image field names from the API
          let imageUrl = product.image || product.featured_image || product.featured_media?.preview_image?.url;
          
          // Resize image URL to 300x for better quality
          if (imageUrl) {
            // Check if URL already has query parameters
            if (imageUrl.includes('?')) {
              // Replace or add width parameter
              if (imageUrl.includes('width=')) {
                imageUrl = imageUrl.replace(/width=\d+/i, 'width=300');
              } else {
                imageUrl += '&width=300';
              }
            } else {
              // No query params, add width
              imageUrl += '?width=300';
            }
          }
          
          const imageHtml = imageUrl ? `
            <div class="predictive-search__image-wrapper">
              <img 
                src="${imageUrl}" 
                alt="${product.title}"
                class="predictive-search__image"
                loading="lazy"
                width="50"
                height="50"
              />
            </div>
          ` : '';
          
          html += `
            <a href="${product.url}" class="predictive-search__item predictive-search__item--product">
              ${imageHtml}
              <div class="predictive-search__item-content">
                <span class="predictive-search__item-title">${product.title}</span>
                <span class="predictive-search__item-price">${product.price}</span>
              </div>
            </a>
          `;
        });
        html += '</div>';
      }

      // Render collections
      if (data.resources?.results?.collections?.length) {
        html += '<div class="predictive-search__section">';
        html += '<h3 class="predictive-search__heading">Collections</h3>';
        data.resources.results.collections.forEach(collection => {
          html += `
            <a href="${collection.url}" class="predictive-search__item">
              <span class="predictive-search__item-title">${collection.title}</span>
            </a>
          `;
        });
        html += '</div>';
      }

      // Add "View all results" button
      const currentQuery = this.searchInput.value.trim();
      if (currentQuery) {
        html += `
          <div class="predictive-search__view-all">
            <a href="/search?q=${encodeURIComponent(currentQuery)}" class="predictive-search__view-all-button">
              <span>Search for "${currentQuery}"</span>
              <svg class="icon icon-search" aria-hidden="true" focusable="false" width="16" height="16">
                <use href="#icon-search"></use>
              </svg>
            </a>
          </div>
        `;
      }
      
      html += '</div>';

      if (data.resources?.results?.queries?.length || data.resources?.results?.products?.length || data.resources?.results?.collections?.length) {
        this.showPredictiveSearchResults(html);
      } else {
        this.hidePredictiveSearch();
      }
    }

    showPredictiveSearchLoading() {
      const predictiveSearchContainer = this.querySelector('.predictive-search--mobile');
      if (predictiveSearchContainer) {
        predictiveSearchContainer.innerHTML = `
          <div class="predictive-search__loading-state">
            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        `;
        predictiveSearchContainer.classList.add('predictive-search--open');
      }
    }

    showPredictiveSearchResults(html) {
      const predictiveSearchContainer = this.querySelector('.predictive-search--mobile');
      if (predictiveSearchContainer) {
        predictiveSearchContainer.innerHTML = html;
        predictiveSearchContainer.classList.add('predictive-search--open');
        
        // Add click handlers to results
        const links = predictiveSearchContainer.querySelectorAll('a');
        links.forEach(link => {
          link.addEventListener('click', () => {
            this.hidePredictiveSearch();
          });
        });
      }
    }

    hidePredictiveSearch() {
      const predictiveSearchContainer = this.querySelector('.predictive-search--mobile');
      if (predictiveSearchContainer) {
        predictiveSearchContainer.classList.remove('predictive-search--open');
        setTimeout(() => {
          predictiveSearchContainer.innerHTML = '';
        }, 200);
      }
    }

    startTypedAnimation() {
      if (this.suggestions.length === 0) return;
      
      this.stopTypedAnimation(); // Clear any existing animation
      this.currentIndex = 0;
      this.currentText = '';
      this.isTyping = false;
      
      // Start the typing cycle
      this.typedTimeoutId = setTimeout(() => {
        this.typeText();
      }, this.startDelay);
    }

    stopTypedAnimation() {
      if (this.typedTimeoutId) {
        clearTimeout(this.typedTimeoutId);
        this.typedTimeoutId = null;
      }
      this.isTyping = false;
    }

    typeText() {
      if (!this.suggestions.length) return;
      
      const targetText = this.suggestions[this.currentIndex];
      this.isTyping = true;
      
      const typeStep = () => {
        if (this.currentText.length < targetText.length) {
          this.currentText += targetText.charAt(this.currentText.length);
          this.updatePlaceholder();
          
          this.typedTimeoutId = setTimeout(typeStep, this.typeSpeed);
        } else {
          // Finished typing, wait then start backspacing
          this.typedTimeoutId = setTimeout(() => {
            this.backspaceText();
          }, this.backDelay);
        }
      };
      
      typeStep();
    }

    backspaceText() {
      if (!this.isTyping) return;
      
      const backspaceStep = () => {
        if (this.currentText.length > 0) {
          this.currentText = this.currentText.slice(0, -1);
          this.updatePlaceholder();
          
          this.typedTimeoutId = setTimeout(backspaceStep, this.backSpeed);
        } else {
          // Finished backspacing, move to next suggestion
          this.currentIndex = (this.currentIndex + 1) % this.suggestions.length;
          this.typedTimeoutId = setTimeout(() => {
            this.typeText();
          }, this.startDelay);
        }
      };
      
      backspaceStep();
    }

    updatePlaceholder() {
      if (this.currentText) {
        this.searchInput.placeholder = `Try searching for.. ${this.currentText}`;
      } else {
        this.searchInput.placeholder = 'Try searching for.. ';
      }
    }

    disconnectedCallback() {
      this.stopTypedAnimation();
      // Clean up header class when component is removed
      const headerSection = document.querySelector('.shopify-section-header');
      if (headerSection) {
        headerSection.classList.remove('is-active');
      }
    }
  }

  // Desktop Search Modal Typing Animation Helper
  class DesktopSearchTypingHelper {
    constructor(searchModalElement) {
      this.searchModalElement = searchModalElement;
      this.detailsElement = searchModalElement.querySelector('details');
      this.searchInput = null;
      this.suggestions = [];
      this.currentIndex = 0;
      this.rotationSpeed = 3000;
      this.typedTimeoutId = null;
      this.isTyping = false;
      this.currentText = '';
      this.typeSpeed = 100;
      this.backSpeed = 50;
      this.startDelay = 500;
      this.backDelay = 1000;
      this.init();
    }

    init() {
      if (!this.detailsElement) return;

      this.detailsElement.addEventListener('toggle', (e) => {
        if (e.target.open) {
          // Modal opened - find the search input
          setTimeout(() => {
            this.searchInput = this.searchModalElement.querySelector('input[type="search"], input[name="q"]');
            if (this.searchInput) {
              this.setupSearchInput();
            }
          }, 100);
        } else {
          // Modal closed - clean up
          this.stopTypedAnimation();
        }
      });
    }

    setupSearchInput() {
      // Get suggestions from mobile search bar settings (reuse the same settings)
      const mobileSearchInput = document.querySelector('.mobile-search-input');
      if (mobileSearchInput) {
        const suggestionsData = mobileSearchInput.dataset.searchSuggestions;
        const rotationSpeed = mobileSearchInput.dataset.rotationSpeed;
        const typeSpeed = mobileSearchInput.dataset.typeSpeed;
        const backspaceSpeed = mobileSearchInput.dataset.backspaceSpeed;
        
        if (suggestionsData) {
          this.suggestions = suggestionsData.split(',').map(s => s.trim()).filter(s => s);
          this.rotationSpeed = parseInt(rotationSpeed) || 3000;
          if (typeSpeed) this.typeSpeed = parseInt(typeSpeed);
          if (backspaceSpeed) this.backSpeed = parseInt(backspaceSpeed);
          
          if (this.suggestions.length > 0) {
            this.startTypedAnimation();
          }
        }
      }

      // Stop typing animation when user focuses on input
      this.searchInput.addEventListener('focus', () => {
        this.stopTypedAnimation();
      });

      // Restart typing animation when user leaves input (if empty)
      this.searchInput.addEventListener('blur', () => {
        if (!this.searchInput.value.trim()) {
          this.startTypedAnimation();
        }
      });

      // Stop typing animation when user types
      this.searchInput.addEventListener('input', () => {
        if (this.searchInput.value.trim()) {
          this.stopTypedAnimation();
        } else if (!this.searchInput.matches(':focus')) {
          this.startTypedAnimation();
        }
      });
    }

    startTypedAnimation() {
      if (this.suggestions.length === 0 || !this.searchInput) return;
      
      this.stopTypedAnimation();
      this.currentIndex = 0;
      this.currentText = '';
      this.isTyping = false;
      
      this.typedTimeoutId = setTimeout(() => {
        this.typeText();
      }, this.startDelay);
    }

    stopTypedAnimation() {
      if (this.typedTimeoutId) {
        clearTimeout(this.typedTimeoutId);
        this.typedTimeoutId = null;
      }
      this.isTyping = false;
    }

    typeText() {
      if (!this.suggestions.length || !this.searchInput) return;
      
      const targetText = this.suggestions[this.currentIndex];
      this.isTyping = true;
      
      const typeStep = () => {
        if (this.currentText.length < targetText.length) {
          this.currentText += targetText.charAt(this.currentText.length);
          this.updatePlaceholder();
          
          this.typedTimeoutId = setTimeout(typeStep, this.typeSpeed);
        } else {
          this.typedTimeoutId = setTimeout(() => {
            this.backspaceText();
          }, this.backDelay);
        }
      };
      
      typeStep();
    }

    backspaceText() {
      if (!this.isTyping || !this.searchInput) return;
      
      const backspaceStep = () => {
        if (this.currentText.length > 0) {
          this.currentText = this.currentText.slice(0, -1);
          this.updatePlaceholder();
          
          this.typedTimeoutId = setTimeout(backspaceStep, this.backSpeed);
        } else {
          this.currentIndex = (this.currentIndex + 1) % this.suggestions.length;
          this.typedTimeoutId = setTimeout(() => {
            this.typeText();
          }, this.startDelay);
        }
      };
      
      backspaceStep();
    }

    updatePlaceholder() {
      if (this.searchInput) {
        if (this.currentText) {
          this.searchInput.placeholder = `Try searching for.. ${this.currentText}`;
        } else {
          this.searchInput.placeholder = 'Try searching for.. ';
        }
      }
    }
  }

  // Initialize mobile search bar when DOM is loaded
  if (customElements.get('mobile-search-bar') === undefined) {
    customElements.define('mobile-search-bar', MobileSearchBar);
  }

  // Initialize existing mobile search bars
  document.addEventListener('DOMContentLoaded', () => {
    const mobileSearchBars = document.querySelectorAll('.mobile-search-bar');
    mobileSearchBars.forEach(bar => {
      if (!customElements.get('mobile-search-bar')) return;
      
      // Convert to custom element if not already
      if (bar.constructor === HTMLDivElement) {
        const newElement = document.createElement('mobile-search-bar');
        newElement.innerHTML = bar.innerHTML;
        newElement.className = bar.className;
        bar.parentNode.replaceChild(newElement, bar);
      }
    });

    // Initialize desktop search modal typing animation
    const desktopSearchModals = document.querySelectorAll('search-modal');
    desktopSearchModals.forEach(modal => {
      new DesktopSearchTypingHelper(modal);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
